import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Apollo} from "apollo-angular";
import {AccountListModel, AccountSummaryGqlModel, ExpenseGqlModel} from "./accounting.gql-model";

@Injectable()
export class AccountingService {
  private url: string = "api/card";

  constructor(private http: HttpClient, private apollo: Apollo) {}

  getExpenses(projectId: string, queryStartDate: string, bucket?: string): Promise<ExpenseGqlModel[]> {
    const query = ExpenseGqlModel.query;
    const variables = ExpenseGqlModel.variables(projectId, queryStartDate, bucket);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(ExpenseGqlModel.mapper)
      .toPromise();
  }

  loadSummary(projectId: string, queryStartDate: string): Promise<AccountSummaryGqlModel> {
    const query = AccountSummaryGqlModel.query;
    const variables = AccountSummaryGqlModel.variables(projectId, queryStartDate);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(AccountSummaryGqlModel.mapper)
      .toPromise();
  }

  getAccountList(projectId: string, search: string, page: number, limit: number): Promise<AccountListModel> {
    const query = AccountListModel.query;
    const variables = AccountListModel.variables(projectId, search, page, limit);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(AccountListModel.mapper)
      .toPromise();
  }

  setAccountToProject(projectId, accountId): Promise<any> {
    return this.http.post(`${this.url}/set-account`, {
      projectId,
      accountId,
    }).toPromise();
  }

  updateExpense(expense: any): Promise<any> {
    return this.http.post(`${this.url}/update-expense`, {expense}).toPromise();
  }

  removeExpense(expense: any): Promise<any> {
    return this.http.post(`${this.url}/remove-expense`, {expense}).toPromise();
  }

  getExpensesAccount(params): Promise<any> {
    return this.http.get(`${this.url}/import-expenses`, {params}).toPromise();
  }
}
